import produce from 'immer';
import { CustomerOfferListItemResponse, FiltersResponse, MetaPagination, CustomerOfferResponse } from '../../../api';
import { baseOffersActions } from '../actions';

export interface OffersState {
  offersList: {
    data: CustomerOfferListItemResponse[] | undefined;
    pagination: MetaPagination | undefined;
    filters: FiltersResponse | undefined;
    ok: boolean | undefined;
  };
  offerDetails: {
    data: CustomerOfferResponse | undefined;
    ok: boolean | undefined;
  };
  downloadOfferedDaysFile: {
    data: Blob | undefined;
  };
}

export const OFFERS_INIT_STATE: OffersState = {
  offersList: {
    data: undefined,
    pagination: undefined,
    filters: undefined,
    ok: undefined,
  },
  offerDetails: {
    data: undefined,
    ok: undefined,
  },
  downloadOfferedDaysFile: {
    data: undefined,
  },
};

export function BaseOffersReducer(state: OffersState = OFFERS_INIT_STATE, action: any): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Offers list
      case baseOffersActions.loadOffersList.type:
        draftState.offersList.ok = undefined;
        return;

      case baseOffersActions.setOffersList.type:
        draftState.offersList.data = action.payload.data;
        draftState.offersList.filters = action.payload.filters;
        draftState.offersList.pagination = action.payload.meta;
        return;

      case baseOffersActions.successOffersList.type:
        draftState.offersList.ok = true;
        return;

      case baseOffersActions.errorOffersList.type:
        draftState.offersList.ok = false;
        return;

      // Offers details
      case baseOffersActions.loadOfferDetails.type:
        draftState.offerDetails.ok = undefined;
        return;

      case baseOffersActions.setOfferDetails.type:
        draftState.offerDetails.data = action.payload;
        return;

      case baseOffersActions.successOfferDetails.type:
        draftState.offerDetails.ok = true;
        return;

      case baseOffersActions.errorOfferDetails.type:
        draftState.offerDetails.ok = false;
        return;

      // Download offered days file
      case baseOffersActions.setDownloadOfferedDaysFile.type:
        draftState.downloadOfferedDaysFile.data = action.payload.document;
        return;

      case baseOffersActions.clearDownloadOfferedDaysFile.type:
        draftState.downloadOfferedDaysFile.data = undefined;
        return;

      default:
        draftState = { ...draftState };
        return;
    }
  });
}
